import { Pipe, PipeTransform } from '@angular/core';
import { dateDiffInDays } from '@shared/utils';

@Pipe({
  name: 'dateDiff',
})
export class DateDiffPipe implements PipeTransform {
  transform(startDate: Date, endDate: Date): string {
    if (!startDate || !endDate) {
      return $localize`:@@dpr.dateDiffPipe.txtDefaultNumberOfSelectedDays:Selected days`;
    }

    // prettier-ignore
    return $localize`:@@dpr.dateDiffPipe.txtNumberOfSelectedDays:${dateDiffInDays(startDate, endDate) + 1}:numberOfDays: Days`;
  }
}
